export default "__VITE_ASSET__BQyh6TXw__"